module.exports = __webpack_public_path__ + "static/img/4.cdbea9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jxhh/4.png
// module id = D00l
// module chunks = 2